import { fetchApiGateway } from "@nova/fetch-api-gateway"
import useSWRMutation from "swr/mutation"
import { invalidateIntegrationAuthorizations } from "features/data-management/integrations/useIntegrations"

interface AuthorizeCalTopoArgs {
    credentialId: string
    secret: string
    map: string
    workspaceId: string
}

interface CalTopoAuthorizationError {
    message: string
    cause: string
}

const authorize = async (
    _key: string,
    { arg: { credentialId, secret, map, workspaceId } }: { arg: AuthorizeCalTopoArgs }
) => {
    const res = await fetchApiGateway("post /org/:orgId/integrations/caltopo/authorize", {
        params: { orgId: workspaceId },
        body: { credentialId, secret, map },
        rawResponse: true,
    })

    if (res.status === 422) {
        throw {
            cause: "map",
            message: "Enter a CalTopo map ID or map URL.",
        } as CalTopoAuthorizationError
    }

    if (res.status === 502) {
        throw {
            cause: "credentials",
            message: "CalTopo rejected these credentials, or the map is not accessible.",
        } as CalTopoAuthorizationError
    }

    if (!res.ok) {
        throw {
            cause: "network",
            message: "Failed to connect to CalTopo.",
        } as CalTopoAuthorizationError
    }
}

const useAuthorizeCalTopo = (
    onSuccess: () => void,
    onError: (error: CalTopoAuthorizationError) => void
) => {
    const {
        trigger: authorizeCalTopo,
        isMutating,
        error,
    } = useSWRMutation("caltopo-authorize", authorize, {
        onSuccess: () => {
            invalidateIntegrationAuthorizations()
            onSuccess()
        },
        onError,
        throwOnError: false,
    })

    return { authorizeCalTopo, isMutating, error }
}

export { useAuthorizeCalTopo }
export type { CalTopoAuthorizationError }
